<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on }">
      <v-tooltip bottom>
        <template v-slot:activator="tltip">
          <div v-on="tltip.on">
            <v-btn class="mr-2" small icon color="white" v-on="on">
              <v-icon>fa-qrcode</v-icon>
            </v-btn>
          </div>
        </template>
        <span>{{$t("scanQRCode")}}</span>
      </v-tooltip>
      <!-- <v-btn class="mr-2" small icon color="white" v-on="on">
        <v-icon>fa-qrcode</v-icon>
      </v-btn>-->
    </template>
    <v-card v-if="dialog">
      <v-tabs fixed-tabs>
        <v-tab left ripple>{{$t("scanQRCode")}}</v-tab>
        <v-tab-item>
          <qrcode-stream @decode="onDecode"></qrcode-stream>
        </v-tab-item>
      </v-tabs>
    </v-card>

    <template>
      <v-layout row justify-center>
        <v-dialog v-model="warning" max-width="500px">
          <v-card>
            <v-alert :value="true" type="warning">{{$t('warning')}}</v-alert>
            <v-card-text>{{$t('qrcodeNotLinked')}}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="warning = false">{{$t('close')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
  </v-dialog>
</template>

<script>
export default {
  name: "addQRCode",
  data: () => ({
    show: false,
    dialog: false,
    warning: false,
    success: false,
    qrId: ""
  }),
  props: {
    marker: Object
  },
  methods: {
    close() {
      this.dialog = false;
    },
    onDecode(url) {
      this.qrId = url.substr(url.lastIndexOf("/") + 1);
      if (this.$validator.isUUID(this.qrId)) {
        if (this.$store.state.markers.find(x => x.qrId == this.qrId)) {
          this.$emit(
            "showMarkerDetails",
            this.$store.state.markers.find(x => x.qrId == this.qrId)
          );
        } else if (
          this.$store.state.markersReadonly.find(x => x.qrId == this.qrId)
        ) {
          this.$emit(
            "showMarkerDetails",
            this.$store.state.markersReadonly.find(x => x.qrId == this.qrId)
          );
        } else {
          this.warning = true;
        }
      }
    }
  },
  created() {}
};
</script>




// WEBPACK FOOTER //
// src/components/pages/Markers/ScanQRCode.vue